import { NavLink } from "react-router-dom";
import { cn } from "lib/utils";

function base() {
  return localStorage.getItem("authUserType") === "admin" ? "/admin/crm" : "/employee/crm";
}

/** The views of the LinkedIn Outreach hub, as a segmented switch (kept visually apart from the stage tabs inside Today).
 *  Today stays at `…/crm/due-today`; the other views sit under it. */
export default function LinkedInHubTabs() {
  const views = [
    { label: "Today", to: `${base()}/due-today`, end: true },
    { label: "Pipeline", to: `${base()}/due-today/pipeline`, end: false },
    { label: "Conversations", to: `${base()}/due-today/conversations`, end: false },
    { label: "Performance", to: `${base()}/due-today/performance`, end: false },
  ];
  return (
    <nav aria-label="LinkedIn Outreach views" className="inline-flex rounded-lg border border-border bg-surface-muted p-0.5">
      {views.map((v) => (
        <NavLink
          key={v.label}
          to={v.to}
          end={v.end}
          className={({ isActive }) => cn(
            "rounded-md px-3.5 py-1.5 text-sm font-medium transition-colors",
            isActive ? "bg-surface text-primary shadow-sm" : "text-muted-foreground hover:text-foreground",
          )}
        >
          {v.label}
        </NavLink>
      ))}
    </nav>
  );
}
